export default __webpack_public_path__ + "static/media/lllogo.9728765f.png";